// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// ----------------------------------------------------------------------
// components
import SvgIconStyle from '../../../components/SvgIconStyle';
// ----------------------------------------------------------------------
const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  lookUp: getIcon('ic_lookup'),
  dmts: getIcon('ic_dmts'),
  ums: getIcon('ic_ums'),
  itsms: getIcon('ic_itsms'),
  hr: getIcon('ic_hr'),
  archive: getIcon('ic_archive'),
  reception: getIcon('ic_reception'),
  news: getIcon('ic_news'),
  administrative: getIcon('ic_administrative'),
  bookdiary: getIcon('ic_bookdiary'),
  map: getIcon('map'),
  contract: getIcon('contract'),
};

const navConfig = [
  // GENERAL

  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      // { title: 'application', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'application', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      // { title: 'ecommerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    // Lookup Table
    items: [
      {
        title: 'hr',
        path: '#1',
        icon: ICONS.hr,
        roles: [
          'EmployeeProfile-GetList',
          'Province-GetList',
          'District-GetList',
          'HRContractType-GetList',
          'PositionTitle-GetList',
        ],
        children: [
          {
            title: 'setting',
            path: '#2',
            roles: [],
            children: [
              {
                title: 'province',
                path: PATH_DASHBOARD.Province.list,
                roles: ['Province-GetList'],
              },
              {
                title: 'district',
                path: PATH_DASHBOARD.district.list,
                roles: ['District-GetList'],
              },
              {
                title: 'contractType',
                path: PATH_DASHBOARD.ContractType.list,
                roles: ['HRContractType-GetList'],
              },
              {
                title: 'positionTitle',
                path: PATH_DASHBOARD.PositionTitle.list,
                roles: ['PositionTitle-GetList'],
              },
            ],
          },

          {
            title: 'emp',
            path: PATH_DASHBOARD.Employee.list,
            roles: ['EmployeeProfile-GetList'],
          },
        ],
      },
      // UMS
      {
        title: 'UMS',
        path: '#1',
        icon: ICONS.ums,
        roles: [
          'User-Create',
          'User-GetList',
          'User-PasswordReset',
          'Permission-GetList',
          'Role-GetList',
          'Role-Create',
          // 'Application-GetAll',
        ],
        children: [
          {
            title: 'UserManagement',
            path: '#2',
            roles: ['User-Create', 'User-GetList', 'User-UserLog', 'User-PasswordReset'],
            children: [
              { title: 'createUser', path: PATH_DASHBOARD.user.new, roles: ['User-Create'] },
              { title: 'Userlist', path: PATH_DASHBOARD.user.list, roles: ['User-GetList'] },
              { title: 'UserLogList', path: PATH_DASHBOARD.user.Loglist, roles: ['User-UserLog'] },
              {
                title: 'changePassword',
                path: PATH_DASHBOARD.user.changePassword,
              },
              // {
              //   title: 'Enable2fa',
              //   path: PATH_DASHBOARD.user.googleAuth,
              // },
            ],
          },
          {
            title: 'Role',
            path: '#4',
            roles: ['Role-GetList', 'Role-Create'],
            children: [
              { title: 'list', path: PATH_DASHBOARD.Role.list, roles: ['Role-GetList'] },
              { title: 'create', path: PATH_DASHBOARD.Role.new, roles: ['Role-Create'] },
            ],
          },
        ],
      },

      {
        title: 'estates',
        path: '#1',
        icon: ICONS.banking,
        roles: [
          'Block-GetList',

          'Floor-GetList',

          'ElectricBox-GetList',

          'ElectricMeter-GetList',

          'ShopType-GetList',

          'Status-GetList',
          'Shop-GetShopReport',
          'Shop-GetList',
        ],
        children: [
          {
            title: 'setting',
            path: '#2',
            roles: [
              'Block-GetList',

              'Floor-GetList',

              'ElectricBox-GetList',

              'ElectricMeter-GetList',

              'ShopType-GetList',

              'Status-GetList',
            ],
            children: [
              {
                title: 'block',
                path: PATH_DASHBOARD.Block.list,
                roles: ['Block-GetList'],
              },
              {
                title: 'floor',
                path: PATH_DASHBOARD.Floor.list,
                roles: ['Floor-GetList'],
              },
              {
                title: 'electricBox',
                path: PATH_DASHBOARD.ElectricBox.list,
                roles: ['ElectricBox-GetList'],
              },
              {
                title: 'electricMeter',
                path: PATH_DASHBOARD.ElectricMeter.list,
                roles: ['ElectricMeter-GetList'],
              },
              {
                title: 'shopType',
                path: PATH_DASHBOARD.ShopType.list,
                roles: ['ShopType-GetList'],
              },
              // {
              //   title: 'status',
              //   path: PATH_DASHBOARD.Status.list,
              //   roles: ['Status-GetAll'],
              // },
            ],
          },
          {
            title: 'shops',
            path: PATH_DASHBOARD.Shop.list,
            roles: ['Shop-GetList'],
          },
          {
            title: 'report',
            path: PATH_DASHBOARD.Shop.report,
            roles: ['Shop-GetShopReport'],
          },
        ],
      },
      {
        title: 'contract',
        path: '#1',
        icon: ICONS.contract,
        roles: [
          'TermsAndCondition-GetList',
          'ContractType-GetList',
          'Customer-GetList',
          'Contract-GetContractReport',
          'Contract-GetList',
          'Contract-GetList_unapproved',
          'Contract-GetList_approved',
          'Contract-GetList_expired',
          'Contract-GetList_about_to_expire',
          'Contract-GetList_terminated',
          'Contract-GetDetail',
          'Contract-GetContractHistoryList',
        ],
        children: [
          {
            title: 'setting',
            path: '#2',
            roles: ['TermsAndCondition-GetList', 'ContractType-GetList'],
            children: [
              {
                title: 'termsAndCondition',
                path: PATH_DASHBOARD.TermsAndCondition.list,
                roles: ['TermsAndCondition-GetList'],
              },
              {
                title: 'contractTypes',
                path: PATH_DASHBOARD.ShopContractType.list,
                role: ['ContractType-GetList'],
              },
            ],
          },
          {
            title: 'customer',
            path: PATH_DASHBOARD.Customer.list,
            roles: ['Customer-GetList'],
          },
          {
            title: 'contract',
            path: '#2',
            role: ['TermsAndCondition-GetList', 'ContractType-GetList'],
            children: [
              {
                title: 'contractInfo',
                path: PATH_DASHBOARD.ContractInfo.list,
                roles: ['Contract-GetList'],
              },
              {
                title: 'activeContract',
                path: PATH_DASHBOARD.ContractInfo.activeContract,
                roles: ['Contract-GetList_active'],
              },
              {
                title: 'unapproved',
                path: PATH_DASHBOARD.ContractInfo.unapproved,
                roles: ['Contract-GetList_unapproved'],
              },
              {
                title: 'approved',
                path: PATH_DASHBOARD.ContractInfo.approved,
                roles: ['Contract-GetList_approved'],
              },

              {
                title: 'aboutexpired',
                path: PATH_DASHBOARD.ContractInfo.abouttoexpired,
                roles: ['Contract-GetList_about_to_expire'],
              },
              {
                title: 'expired',
                path: PATH_DASHBOARD.ContractInfo.expired,
                roles: ['Contract-GetList_expired'],
              },
              {
                title: 'terminated',
                path: PATH_DASHBOARD.ContractInfo.terminated,
                roles: ['Contract-GetList_terminated'],
              },
            ],
          },

          {
            title: 'contractReport',
            path: PATH_DASHBOARD.ContractInfo.report,
            roles: ['Contract-GetContractReport'],
          },
        ],
      },
      {
        title: 'finance',
        path: '#1',
        icon: ICONS.ecommerce,
        roles: ['ElectricityPayment-GetList', 'RentPayment-GetList'],
        children: [
          {
            title: 'rentPaymentInfo',
            path: '#2',
            roles: ['RentPayment-GetList'],
            children: [
              {
                title: 'rentPayment',
                path: PATH_DASHBOARD.RentPayment.list,
                roles: ['RentPayment-GetList'],
              },
              {
                title: 'rentPaymentReport',
                path: PATH_DASHBOARD.RentPayment.report,
                roles: ['RentPayment-GetRentPaymentReport'],
              },
            ],
          },
          {
            title: 'electricityPaymentInfo',
            path: '#2',
            roles: ['ElectricityPayment-GetList'],
            children: [
              {
                title: 'electricPayment',
                path: PATH_DASHBOARD.ElectricityPayment.list,
                roles: ['ElectricityPayment-GetList'],
              },
              {
                title: 'electricityReport',
                path: PATH_DASHBOARD.ElectricityPayment.report,
                roles: ['ElectricityPayment-GetElectricityPaymentReportDaily'],
              },
            ],
          },
        ],
      },
      {
        title: 'incomes',
        path: '#1',
        icon: ICONS.banking,
        roles: ['Income-GetList', 'IncomeCategory-GetList'],
        children: [
          {
            title: 'setting',
            path: '#2',
            icon: ICONS.administrative,
            roles: ['IncomeCategory-GetList'],
            children: [
              {
                title: 'categorys',
                path: PATH_DASHBOARD.IncomeCategory.list,
                roles: ['IncomeCategory-GetList'],
              },
            ],
          },
          {
            title: 'incomeCollecting',
            path: PATH_DASHBOARD.Income.list,
            roles: ['Income-GetList'],
          },
          {
            title: 'financialPayments',
            path: PATH_DASHBOARD.FinancialPayment.list,
            roles: ['FinancialPayment-GetList'],
          },
          {
            title: 'reports',
            path: PATH_DASHBOARD.Income.report,
            roles: ['Income-GetList'],
          },
        ],
      },
      {
        title: 'map',
        path: PATH_DASHBOARD.ChoqoralMap.map,
        icon: ICONS.map,
        roles: ['Shop-GetShopForMap'],
      },

      // {
      //   title: 'trainingVideo',
      //   path: '#1',
      //   icon: ICONS.news,
      //   //roles: ['Employee-GetAll', 'CardDetails-GetPrintableCardList'],
      //   children: [
      //     {
      //       title: 'addTrainingVideo',
      //       path: PATH_DASHBOARD.TrainingVideo.new,
      //       roles: ['TrainingVideo-Create'],
      //     },
      //     {
      //       title: 'trainingVideolist',
      //       path: PATH_DASHBOARD.TrainingVideo.list,
      //     },
      //     {
      //       title: 'trainingVideoPlayer',
      //       path: PATH_DASHBOARD.TrainingVideo.videoPlayer,
      //       //roles: ['Employee-GetAll'],
      //     },
      //   ],
      // },
    ],
  },
];

export default navConfig;
